module.exports = __webpack_public_path__ + "img/52800.0b2d1e25.jpg";